import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type ThemeName = "dark" | "light";

export const useDefaultTheme = () =>
  useQuery({
    queryKey: ["site_settings", "default_theme"],
    queryFn: async (): Promise<ThemeName> => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "default_theme")
        .maybeSingle();
      if (error) throw error;
      const v = data?.value;
      return v === "light" ? "light" : "dark";
    },
    staleTime: 5 * 60_000,
  });

export const useUpdateDefaultTheme = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (theme: ThemeName) => {
      const { error } = await supabase
        .from("site_settings")
        .upsert([{ key: "default_theme", value: theme, updated_at: new Date().toISOString() }]);
      if (error) throw error;
      return theme;
    },
    onSuccess: (theme) => {
      qc.setQueryData(["site_settings", "default_theme"], theme);
    },
  });
};
